export default __webpack_public_path__ + "static/media/user-img.cc434282.png";